import { render, staticRenderFns } from "./data-abstract.vue?vue&type=template&id=92b86992&scoped=true"
import script from "./data-abstract.vue?vue&type=script&lang=js"
export * from "./data-abstract.vue?vue&type=script&lang=js"
import style0 from "./data-abstract.vue?vue&type=style&index=0&id=92b86992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b86992",
  null
  
)

export default component.exports